module.exports = __webpack_public_path__ + "img/lg-gobran-footer-1-1.2e08534f.png";